import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Initialiser Sentry pour le tracking d'erreurs (avant tout le reste)
import { initSentry } from './lib/sentry';
initSentry();

// Initialiser le thème avant le rendu
import './stores/themeStore';

// Désinstaller tous les service workers en développement
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });
}

// Nettoyer les anciennes clés de session Supabase corrompues
if (import.meta.env.DEV && typeof window !== 'undefined') {
  // Supprimer les anciennes clés qui pourraient être corrompues
  const keysToRemove = Object.keys(localStorage).filter(key =>
    key.startsWith('sb-') || key.includes('supabase')
  );

  if (keysToRemove.length > 0 && !localStorage.getItem('session-cleaned')) {
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
    localStorage.setItem('session-cleaned', 'true');
    window.location.reload();
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
